/**
 * @generated SignedSource<<7a2bd0836bf05d2e0c26f3a7166f70ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type superSplashLargeLiveWidget$data = {
  readonly description: string | null | undefined;
  readonly label: string | null | undefined;
  readonly relatedArticles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "superSplashLargeLiveWidget";
};
export type superSplashLargeLiveWidget$key = {
  readonly " $data"?: superSplashLargeLiveWidget$data;
  readonly " $fragmentSpreads": FragmentRefs<"superSplashLargeLiveWidget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "superSplashLargeLiveWidget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "relatedArticles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "contentItemRenderContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LiveWidget",
  "abstractKey": null
};

(node as any).hash = "268249ba85e6919d1ed79f8d518067a3";

export default node;
